import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-image-preview',
  templateUrl: './image-preview.component.html',
  styleUrls: ['./image-preview.component.scss']
})
export class ImagePreviewComponent implements OnInit, OnChanges {
  @Input() imgsrc: string;
  @Input() width: string = 'auto';
  @Input() height: string = '4em';
  @Input() alt: string = 'Imagen';

  imageURL: SafeResourceUrl = 'assets/img/loading.gif';

  constructor(private h: HttpClient, private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    if (this.imgsrc) {
      this.loadImage(this.imgsrc);
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['imgsrc'] && this.imgsrc) {
      this.loadImage(this.imgsrc);
    }
  }

  loadImage(url: string) {
    this.h.get(url, {
      headers: {
        'accept': 'image/webp,image/*,*/*;q=0.8'
      },
      responseType: 'blob'
    }).subscribe({
      next: blob => {
        const objectUrl = URL.createObjectURL(blob);
        this.imageURL = this.sanitizer.bypassSecurityTrustUrl(objectUrl);
      },
      error: err => {
        console.error('Error cargando imagen', err);
        //this.imageURL = 'assets/img/error.png'; // imagen por defecto si falla
      }
    });
  }
}
